import { type FC } from "react";
import { Button } from "@mui/material";

interface Props {
  loginWithRedirect: () => Promise<void>;
}

const LoginButton: FC<Props> = ({ loginWithRedirect }) => {
  return (
    <Button
      style={{ color: "#4397ea", borderColor: "#4397ea" }}
      variant="outlined"
      onClick={() => {
        loginWithRedirect();
      }}
    >
      Log in
    </Button>
  );
};

export default LoginButton;
